<div class="breadcrumb-area">
	<h1>Cuentas Bancarias</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Cuentas Bancarias <a (click)="creating = true" *ngIf="!creating"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Una cuenta se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva la cuenta dando
			click sobre el icono antes mencionado.</p>
		<div class="row">
			<div class="col-sm-4 new-family" *ngIf="creating">
				<h4 id="pin-container">Crea una cuenta<i (click)="alwaysCreating=!alwaysCreating"
						[class.opacity-20]="!alwaysCreating" class="fa fa-thumbtack"></i></h4>
				<span>Datos de la cuenta bancaria</span>
				<div class="input-group input-group-sm">
					<label for="alias" class="input-group-text">Alias</label>
					<input type="text" name="alias" placeholder="Ingresa el alias para la cuenta"
						[(ngModel)]="newAccount.alias" id="alias" class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="accountNumber" class="input-group-text">Número de cuenta</label>
					<input type="text" name="accountNumber" placeholder="Ingresa el número de cuenta"
						[(ngModel)]="newAccount.accountNumber" id="accountNumber" class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="bank" class="input-group-text">Banco</label>
					<select name="bank" id="bank" [(ngModel)]="newAccount.bank" class="form-select">
						<option *ngFor="let bank of accountOptions.erpBanks" value="{{bank.id}}">{{bank.name}}</option>
					</select>
				</div>
				<div class="input-group input-group-sm">
					<label for="type" class="input-group-text">Tipo de cuenta</label>
					<select name="type" id="type" [(ngModel)]="newAccount.bankAccountType" class="form-select">
						<option *ngFor="let bankAccType of accountOptions.bankAccountTypes" value="{{bankAccType.id}}">
							{{bankAccType.name}}</option>
					</select>
				</div>
				<div class="input-group input-group-sm">
					<label for="balance" class="input-group-text">Balance</label>
					<input type="number" placeholder="Ingresa el balance de la cuenta" name="balance"
						[(ngModel)]="newAccount.balance" placeholder="0.00" id="balance" class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="currency" class="input-group-text">Moneda</label>
					<select name="currency" id="currency" [(ngModel)]="newAccount.currency" class="form-select">
						<option *ngFor="let currency of accountOptions.currencies" value="{{currency.id}}">
							{{currency.name}}</option>
					</select>
				</div>
				<div class="input-group input-group-sm">
					<label for="international" class="input-group-text">Alcance</label>
					<select name="international" id="international" [(ngModel)]="newAccount.international" class="form-select">
						<option value="{{false}}">Local</option>
						<option value="{{true}}">Internacional</option>
					</select>
				</div>
				<div class="button-container">
					<button class="btn btn-danger" (click)="cancel()"><i class="fa fa-xmark"></i>CANCELAR</button>
					<button class="btn btn-primary" (click)="create()"
						[disabled]="!newAccount.alias || !newAccount.accountNumber"><i
							class="fa fa-floppy-disk"></i>GUARDAR</button>
				</div>
			</div>
			<div [ngClass]="creating?'col-sm-8':'col'">
				<div class="table table-responsive">
					<table class="table">
						<thead>
							<tr>
								<th class="ta">
									Estado
								</th>
								<th class="ta">
									Alias
								</th>
								<th>
									Número de Cuenta
								</th>
								<th>
									Banco
								</th>
								<th>
									Balance
								</th>
								<th>
									Tipo
								</th>
								<th>
									Moneda
								</th>
								<th>Internacional</th>
								<th class="ta">
									Opción
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let account of filterAccounts">
								<tr [class.tr-hide]="edit!=0 && edit!=account.id">
									<td class="ta">
										<i class="status-category fa fa-power-off" (click)="activeOrInactive(account)"
											[class.active-category]="account.active"></i>
									</td>
									<td>
										<ng-container *ngIf="edit!=account.id">
											{{account.alias}}
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="edit==account.id">
											<input type="text" name="alias-edit" [(ngModel)]="account.alias"
												id="alias-edit" class="form-control">
										</div>
									</td>
									<td>
										<ng-container *ngIf="edit!=account.id">
											{{account.accountNumber}}
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="edit==account.id">
											<input type="text" name="account-number-edit"
												[(ngModel)]="account.accountNumber" id="account-number-edit"
												class="form-control">
										</div>
									</td>
									<td>
										{{getBankName(account.bank)}}
									</td>
									<td>
										{{account.balance}}
									</td>
									<td>
										<ng-container *ngIf="edit!=account.id">
											{{getBankAccountTypeName(account.bankAccountType)}}
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="edit==account.id">
											<select name="bank-edit" id="bank-edit" class="form-select"
												[(ngModel)]="account.bankAccountType">
												<option *ngFor="let bank of accountOptions.bankAccountTypes"
													value="{{bank.id}}">{{bank.name}}</option>
											</select>
										</div>
									</td>
									<td>
										<ng-container *ngIf="edit!=account.id">
											{{getCurrencyName(account.currency)}}
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="edit==account.id">
											<select name="bank-edit" id="bank-edit" class="form-select" [(ngModel)]="account.currency">
												<option *ngFor="let currency of accountOptions.currencies"
													value="{{currency.id}}">{{currency.name}}</option>
											</select>
										</div>
									</td>
									<td class="ta">
										<ng-container *ngIf="edit!=account.id">
											<span tooltip="Internacional" *ngIf="account.international"><i class="fa fa-globe text-primary" aria-hidden="true"></i></span>
											<span tooltip="Local" *ngIf="!account.international"><i class="fa fa-map-marker text-secondary" aria-hidden="true"></i></span>
										</ng-container>
										<div *ngIf="edit==account.id">
											<span class="cursor-pointer" tooltip="Internacional" *ngIf="account.international" (click)="account.international=!account.international"><i class="fa fa-globe text-primary" aria-hidden="true"></i></span>
											<span class="cursor-pointer" tooltip="Local" *ngIf="!account.international" (click)="account.international=!account.international"><i class="fa fa-map-marker text-secondary" aria-hidden="true"></i></span>
										</div>
									</td>
									<td class="ta">
										<span [class.a-hover]="edit!=account.id" (click)="editAndSave(account)"><i
												class="fa"
												[ngClass]="edit==account.id?'fa-floppy-disk':'fa-edit'"></i></span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>